export default __webpack_public_path__ + "static/media/loading.ff862c73.gif";